import { Clock, Calendar } from 'lucide-react';

const DiaCulto = ({dia,horario,nomedoculto,descricao}) => {
    return <div className="bg-blue-800 p-8 rounded-xl shadow-lg transform hover:scale-105 transition-transform duration-300 animate-slide-in-left delay-500">
        <Calendar className="w-12 h-12 mx-auto mb-4 text-blue-300" />
        <h3 className="text-3xl font-semibold mb-4">{dia}</h3>
        <p className="text-lg mb-2 flex items-center justify-center">
            <Clock className="w-5 h-5 mr-2" /> {horario}
        </p>
        <p className="text-base opacity-80">{nomedoculto}</p>
        <p className="text-sm italic mt-2">{descricao}</p>
    </div>
}
export default DiaCulto